export default __webpack_public_path__ + "static/media/header-logo-white_mobile.159b9425.svg";